<template>
	<div class="unsubscribe-page">
		<div class="unsubscribe-card">

			<transition name="icon-morph" mode="out-in">
				<svg v-if="status == 'confirm'" key="confirm" class="result-icon result-icon--confirm" viewBox="0 0 80 80">
					<circle class="result-icon__circle" cx="40" cy="40" r="36" fill="none"/>
					<path class="result-icon__envelope" fill="none" d="M22 28 h36 v26 h-36 z M22 28 L40 44 L58 28"/>
				</svg>
				<svg v-else-if="status == 'loading'" key="loading" class="result-icon result-icon--loading" viewBox="0 0 80 80">
					<circle class="result-icon__track" cx="40" cy="40" r="36" fill="none"/>
					<circle class="result-icon__spin" cx="40" cy="40" r="36" fill="none"/>
				</svg>
				<svg v-else-if="status == 'success'" key="success" class="result-icon result-icon--success" viewBox="0 0 80 80">
					<circle class="result-icon__circle" cx="40" cy="40" r="36" fill="none"/>
					<path class="result-icon__check" fill="none" d="M24 41 L35 52 L57 28"/>
				</svg>
				<svg v-else-if="status == 'error'" key="error" class="result-icon result-icon--error" viewBox="0 0 80 80">
					<circle class="result-icon__circle" cx="40" cy="40" r="36" fill="none"/>
					<path class="result-icon__cross" fill="none" d="M28 28 L52 52 M52 28 L28 52"/>
				</svg>
				<svg v-else key="cancelled" class="result-icon result-icon--info" viewBox="0 0 80 80">
					<circle class="result-icon__circle" cx="40" cy="40" r="36" fill="none"/>
					<line class="result-icon__dot" x1="40" y1="36" x2="40" y2="54"/>
					<circle class="result-icon__dot-top" cx="40" cy="26" r="1"/>
				</svg>
			</transition>

			<transition name="text-fade" mode="out-in">
				<div :key="status">
					<p class="unsubscribe-title">{{ title }}</p>
					<p class="unsubscribe-message">{{ message }}</p>
				</div>
			</transition>

			<transition name="text-fade">
				<div v-if="status == 'confirm'" class="unsubscribe-actions">
					<button class="unsubscribe-btn unsubscribe-btn--ghost" @click="cancelUnsubscribe">Cancel</button>
					<button class="unsubscribe-btn unsubscribe-btn--primary" @click="confirmUnsubscribe">Yes, Unsubscribe</button>
				</div>
			</transition>

		</div>
	</div>
</template>
<script>
	import {put} from '@/services/index.js';

	export default{
		metaInfo(){
      return {title:'Unsubscribe'}
    },
		data(){
			return{
				status: 'confirm',
				title: 'Unsubscribe from Marketing Emails',
				message: 'Are you sure you want to stop receiving marketing emails from us?'
			}
		},
		computed:{
			query(){
				return this.$route.query
			},
			guestProfileId(){
				return this.query.guest_profile_id
			}
		},
		mounted(){
			if(!this.guestProfileId){
				this.status = 'error'
				this.title = 'Invalid Link'
				this.message = 'This unsubscribe link is invalid or incomplete.'
			}
		},
		methods:{
			confirmUnsubscribe(){
				this.status = 'loading'
				this.title = 'Unsubscribing...'
				this.message = 'Please wait a moment.'
				put('CORE_HOTEL',`guest-profile/${this.guestProfileId}/unsubscribe-marketing`,{}).then(response=>{
					this.status = 'success'
					this.title = 'Unsubscribed'
					this.message = 'You have been unsubscribed from marketing emails.'
				}).catch(error=>{
					this.status = 'error'
					this.title = 'Something Went Wrong'
					this.message = 'We could not process your request, please try again later.'
				})
			},
			cancelUnsubscribe(){
				this.status = 'cancelled'
				this.title = 'No Changes Made'
				this.message = 'You are still subscribed to marketing emails.'
			}
		}
	}
</script>
<style scoped>
	.unsubscribe-page{
		min-height: 100vh;
		width: 100%;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 24px;
	}
	.unsubscribe-card{
		text-align: center;
		max-width: 380px;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.unsubscribe-title{
		font-size: 19px;
		font-weight: 600;
		margin: 20px 0 8px;
		color: #1a1a1a;
	}
	.unsubscribe-message{
		font-size: 14px;
		line-height: 1.5;
		color: #666;
		margin: 0;
	}
	.unsubscribe-actions{
		display: flex;
		gap: 12px;
		margin-top: 24px;
		width: 100%;
	}
	.unsubscribe-btn{
		flex: 1;
		border: none;
		border-radius: 8px;
		padding: 12px 16px;
		font-size: 14px;
		font-weight: 600;
		cursor: pointer;
		transition: opacity .15s ease;
	}
	.unsubscribe-btn:hover{
		opacity: .85;
	}
	.unsubscribe-btn--ghost{
		background: #f2f2f4;
		color: #444;
	}
	.unsubscribe-btn--primary{
		background: var(--merchant-primary-color, #6c5ce7);
		color: #fff;
	}

	/* icon frame shared by every state so size/position never jumps */
	.result-icon{
		width: 84px;
		height: 84px;
	}

	/* cross-fade + slight scale when the icon itself changes (confirm -> loading -> result) */
	.icon-morph-enter-active,
	.icon-morph-leave-active{
		transition: opacity .25s ease, transform .25s ease;
	}
	.icon-morph-enter{
		opacity: 0;
		transform: scale(.85);
	}
	.icon-morph-leave-to{
		opacity: 0;
		transform: scale(1.1);
	}

	.text-fade-enter-active,
	.text-fade-leave-active{
		transition: opacity .2s ease, transform .2s ease;
	}
	.text-fade-enter,
	.text-fade-leave-to{
		opacity: 0;
		transform: translateY(4px);
	}

	.result-icon__circle{
		stroke-width: 4;
		stroke-linecap: round;
		stroke-dasharray: 226;
		stroke-dashoffset: 226;
		animation: circle-draw .5s ease-out forwards;
	}
	.result-icon--confirm .result-icon__circle{
		stroke: var(--merchant-primary-color, #6c5ce7);
	}
	.result-icon--success .result-icon__circle{
		stroke: #2ecc71;
	}
	.result-icon--error .result-icon__circle{
		stroke: #e74c3c;
	}
	.result-icon--info .result-icon__circle{
		stroke: #9aa0a6;
	}
	.result-icon__envelope{
		stroke: var(--merchant-primary-color, #6c5ce7);
		stroke-width: 3;
		stroke-linecap: round;
		stroke-linejoin: round;
		stroke-dasharray: 130;
		stroke-dashoffset: 130;
		animation: check-draw .5s .15s ease-out forwards;
	}
	.result-icon__check{
		stroke: #2ecc71;
		stroke-width: 5;
		stroke-linecap: round;
		stroke-linejoin: round;
		stroke-dasharray: 48;
		stroke-dashoffset: 48;
		animation: check-draw .35s .2s ease-out forwards;
	}
	.result-icon__cross{
		stroke: #e74c3c;
		stroke-width: 5;
		stroke-linecap: round;
		stroke-dasharray: 68;
		stroke-dashoffset: 68;
		animation: check-draw .35s .2s ease-out forwards;
	}
	.result-icon__dot{
		stroke: #9aa0a6;
		stroke-width: 4;
		stroke-linecap: round;
		stroke-dasharray: 18;
		stroke-dashoffset: 18;
		animation: check-draw .3s .2s ease-out forwards;
	}
	.result-icon__dot-top{
		fill: #9aa0a6;
	}

	/* loading = same circle frame, now spinning, so it reads as a continuation of the envelope/result icon */
	.result-icon__track{
		stroke: #eee;
		stroke-width: 4;
	}
	.result-icon__spin{
		stroke: var(--merchant-primary-color, #6c5ce7);
		stroke-width: 4;
		stroke-linecap: round;
		stroke-dasharray: 170 226;
		transform-origin: center;
		animation: spin .9s linear infinite;
	}

	@keyframes circle-draw{
		to{ stroke-dashoffset: 0; }
	}
	@keyframes check-draw{
		to{ stroke-dashoffset: 0; }
	}
	@keyframes spin{
		to{ transform: rotate(360deg); }
	}
</style>



// WEBPACK FOOTER //
// src/pages/general/MarketingUnsubscribe.vue